import {listPrescription} from '@/api'
import {message} from '../../utils/common'

const BILLING_TYPE_OPTIONS = [
    {value: '0', label: '颗粒', icon: 'Collection'},
    {value: '1', label: '饮片', icon: 'Memo'},
    {value: '2', label: '膏方', icon: 'TakeawayBox'},
    {value: '3', label: '水丸', icon: 'Goods'},
];

export default {
    props: {
        prescriptionDialogVisible: false
    },
    data() {
        return {
            userInfo: null,
            headImg: "",
            sysName: "",
            prescriptionList: [],
            queryParams: {
                docId: null,
                preName: null,
                billingType: ''
            },
            // 当前页码
            currentPage: 1,
            // 每页展示数量
            pageSize: 10,
            total: 0,
            billingTypeOptions: BILLING_TYPE_OPTIONS,
            billingTypeStats: {0: 0, 1: 0, 2: 0, 3: 0},
            billingTypeStatsRequestId: 0,
            prescriptionQueryVersion: 0,
            searchPreName: null,
            queryDocId: null,
            pageType: null,
            choosPreId: null,
            choosePrescriptionDialogVisible: false, // 导入处方
            prescriptionLoading: false,
            prescriptionRequestId: 0,
            chooseSelfTempData: {
                preId: null,
                preName: null,
                instructions: null,
                medInfo: null,
                billingType: null,
                billingTypeName: null
            },
            chooseTempData: {
                tempId: null,
                tempName: null,
                wayFrom: null,
                medInfo: null
            },
            newRuleOpen: false,
        }
    },

    created() {
        this.newRuleOpen = window.sessionStorage.getItem('newRuleOpen');
        // console.log(window.sessionStorage.getItem("user"));
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user") || '{}');
        this.headImg = this.userInfo.avatar;
        this.sysName = this.userInfo.nickName;
        // console.log(this.sysName);
        this.billingType = window.sessionStorage.getItem('billingType');
        let preId = window.sessionStorage.getItem('choosePreId');
        if (preId !== null) {
            this.choosePreId = parseInt(preId);
        }
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.queryDocId = this.doctorInfo.doctorId;
            this.prescriptionList = [];
            this.getPrescriptionList();
        }
    },


    methods: {
        // 选择自建处方
        choosePrescription(item) {
            this.choosePrescriptionDialogVisible = !this.choosePrescriptionDialogVisible;
            this.choosPreId = item.preId;
            this.chooseSelfTempData.preId = item.preId;
            this.chooseSelfTempData.preName = item.preName;
            this.chooseSelfTempData.instructions = item.instructions;
            this.chooseSelfTempData.billingType = item.billingType;
            if (item.billingType !== null && item.billingType !== "" && item.billingType !== undefined) {
                if (item.billingType === '0') {
                    this.chooseSelfTempData.billingTypeName = "颗粒";
                } else if (item.billingType === '1') {
                    this.chooseSelfTempData.billingTypeName = "饮片";
                } else if (item.billingType === '2') {
                    this.chooseSelfTempData.billingTypeName = "膏方";
                } else if (item.billingType === '3') {
                    this.chooseSelfTempData.billingTypeName = "水丸";
                }
            } else {
                this.chooseSelfTempData.billingTypeName = "颗粒";
            }
            let docPrescriptionMedicineArray = item.docPrescriptionMedicineList;
            let medInfo = "";
            if (docPrescriptionMedicineArray.length > 0) {
                docPrescriptionMedicineArray.forEach((medic) => {
                    medInfo += medic.meName;
                    if (medic.decoctionId !== null && medic.decoctionId !== undefined && medic.decoctionId !== '') {
                        medInfo += "(" + medic.decoctionName + ")";
                    }
                    if (medic.decoctWay !== null && medic.decoctWay !== undefined && medic.decoctWay !== '') {
                        medInfo += "(" + medic.decoctWay + ")";
                    }
                    if (item.billingType === "0") {
                        if (medic.newGCount === null) {
                            medic.newGCount = medic.gCount;
                        }
                        if (this.newRuleOpen) {
                            medic.gCount = parseFloat(parseFloat(medic.newGCount) * parseFloat(medic.newRatio)).toFixed(2);
                        } else {
                            medic.gCount = medic.newGCount;
                        }
                    } else {
                        medic.newGCount = medic.gCount;
                    }
                    medInfo += "(" + medic.newGCount + "g)" + ",";
                })
            }
            medInfo = medInfo.substring(0, medInfo.length - 1).replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
            this.chooseSelfTempData.medInfo = medInfo;
        },


        // 替换已有药材
        replaceSelfTempChoose(billingType, preId) {
            this.choosePreId = preId;
            if (this.billingType === billingType) {
                window.sessionStorage.removeItem("medicineList");
                window.sessionStorage.removeItem("preId");
                window.sessionStorage.setItem("choosePreId", preId);
                window.sessionStorage.setItem("addType", "replace");
                this.$emit('preDrawerStatus', false);
            } else {
                this.$confirm('当前所选自建处方剂型与开方剂型不一致，替换将同步修改开方剂型, 是否继续?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    window.sessionStorage.removeItem("medicineList");
                    window.sessionStorage.removeItem("preId");
                    window.sessionStorage.setItem("choosePreId", preId);
                    window.sessionStorage.setItem("addType", "replace");
                    window.sessionStorage.setItem("billingType", billingType);
                    this.$emit('preDrawerStatus', false);
                }).catch(() => {
                    console.log('用户取消更换');
                })

            }

        },

        // 追加到已有药材
        addSelfTempChoose(billingType, preId) {
            this.choosePreId = preId;
            if (this.billingType === billingType) {
                window.sessionStorage.removeItem("preId");
                window.sessionStorage.setItem("choosePreId", preId);
                window.sessionStorage.setItem("addType", "add");
                window.sessionStorage.setItem("billingType", billingType);
                this.$emit('preDrawerStatus', false);
            } else {
                this.$confirm('当前所选自建处方剂型与开方剂型不一致，追加将以替换的形式同步修改开方剂型和药品, 是否继续?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    window.sessionStorage.removeItem("medicineList");
                    window.sessionStorage.removeItem("preId");
                    window.sessionStorage.setItem("choosePreId", preId);
                    window.sessionStorage.setItem("addType", "replace");
                    window.sessionStorage.setItem("billingType", billingType);
                    this.$emit('preDrawerStatus', false);
                }).catch(() => {
                    console.log('用户取消更换');
                })
            }
        },
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        searchPrescriptionList() {
            this.currentPage = 1;
            this.prescriptionList = [];
            this.total = 0;
            this.prescriptionQueryVersion++;
            // 名称/病症筛选只影响列表，不重新计算剂型统计卡片。
            this.getPrescriptionList(true, false);
        },

        chooseBillingType(billingType) {
            this.queryParams.billingType = billingType;
            this.currentPage = 1;
            this.prescriptionList = [];
            this.total = 0;
            this.prescriptionQueryVersion++;
            // 切换剂型只刷新列表，保留已经查询出的各剂型统计数量。
            this.getPrescriptionList(true, false);
        },

        clearBillingType() {
            this.queryParams.billingType = '';
            this.currentPage = 1;
            this.prescriptionList = [];
            this.total = 0;
            this.prescriptionQueryVersion++;
            this.getPrescriptionList(true, true);
        },

        handleCurrentChange(page) {
            this.currentPage = page;
            this.getPrescriptionList(false, false);
        },

        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
            this.getPrescriptionList(false, false);
        },

        resetBillingTypeStats() {
            this.billingTypeOptions.forEach(item => {
                this.billingTypeStats[item.value] = 0;
            });
        },

        // 获取医生常用药方
        getPrescriptionList(force = false, refreshStats = true) {
            if (this.prescriptionLoading && !force) {
                return;
            }
            const requestId = ++this.prescriptionRequestId;
            const queryVersion = this.prescriptionQueryVersion;
            this.prescriptionLoading = true;
            const params = {
                docId: parseInt(this.queryDocId),
                preName: this.searchPreName,
                billingType: this.queryParams.billingType,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                reasonable: "false"
            };
            listPrescription(params).then(response => {
                if (requestId !== this.prescriptionRequestId) {
                    return;
                }
                const rows = response.data.rows || [];
                this.prescriptionList = rows;

                this.prescriptionList.forEach(item => {
                        if (item.billingType !== null && item.billingType !== "" && item.billingType !== undefined) {
                            if (item.billingType === '0') {
                                item.billingTypeName = '颗粒';
                            } else if (item.billingType === '1') {
                                item.billingTypeName = '饮片';
                            } else if (item.billingType === '2') {
                                item.billingTypeName = '膏方';
                            } else if (item.billingType === '3') {
                                item.billingTypeName = '水丸';
                            }
                        } else {
                            item.billingTypeName = '颗粒';
                        }
                        const medicineList = item.docPrescriptionMedicineList;
                        let medInfo = "";
                        if (medicineList.length > 0) {
                            medicineList.forEach((medic) => {
                                medInfo += medic.meName;
                                if (medic.decoctionId !== null && medic.decoctionId !== undefined && medic.decoctionId !== '') {
                                    medInfo += "(" + medic.decoctionName + ")";
                                }
                                if (medic.decoctWay !== null && medic.decoctWay !== undefined && medic.decoctWay !== '') {
                                    medInfo += "(" + medic.decoctWay + ")";
                                }
                                if (item.billingType === "0") {
                                    if (medic.newGCount === null) {
                                        medic.newGCount = medic.gCount;
                                    }
                                    if (this.newRuleOpen) {
                                        medic.gCount = parseFloat(parseFloat(medic.newGCount) * parseFloat(medic.newRatio)).toFixed(2);
                                    } else {
                                        medic.gCount = medic.newGCount;
                                    }
                                } else {
                                    medic.newGCount = medic.gCount;
                                }
                                medInfo += "(" + medic.newGCount + "g)" + ",";
                            })
                        }
                        medInfo = medInfo.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        item.medInfo = medInfo.substring(0, medInfo.length - 1);
                })
                this.total = response.data.total || 0;
                if (refreshStats) {
                    this.loadBillingTypeStats(queryVersion);
                }
            }).catch(error => {
                if (requestId !== this.prescriptionRequestId) {
                    return;
                }
                message(error, "error");
            }).finally(() => {
                if (requestId === this.prescriptionRequestId) {
                    this.prescriptionLoading = false;
                }
            });
        },

        loadBillingTypeStats(queryVersion) {
            const statsRequestId = ++this.billingTypeStatsRequestId;
            const baseParams = {
                docId: parseInt(this.queryDocId),
                // 统计卡片展示医生的全部模版数量，不受输入框筛选条件影响。
                preName: null,
                pageNum: 1,
                pageSize: 1,
                reasonable: "false"
            };
            Promise.all(this.billingTypeOptions.map(item => listPrescription({...baseParams, billingType: item.value})))
                .then(responses => {
                    if (statsRequestId !== this.billingTypeStatsRequestId || queryVersion !== this.prescriptionQueryVersion) {
                        return;
                    }
                    responses.forEach((response, index) => {
                        this.billingTypeStats[this.billingTypeOptions[index].value] = response.data.total || 0;
                    });
                })
                .catch(() => {
                    // 统计卡片失败时不影响处方列表的正常使用。
                });
        },
    }
}